var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-buildify-global-settings-formfield.ts
import { selectionSet } from "@adornis/baseql/utils/queryGeneration.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { FormField } from "@adornis/formfield/form-field.js";
import { customElement, state } from "lit/decorators.js";
import { distinctUntilChanged, filter, switchMap, takeUntil } from "rxjs";
import { BuildifyGlobalSettings, subscribeBuildifyGlobalSettings } from "../../db/GlobalSettings.js";
import { GlobalSettingsClassNameConsumer } from "../globals/consumer.js";
var XBuildifyGlobalSettingsFormField = class extends FormField {
  constructor() {
    super(...arguments);
    this._consumedGlobalSettingsClassName = GlobalSettingsClassNameConsumer(this);
    this._globalSettingsClassName = new RXController(this, void 0);
    this._globalSettings = new RXController(
      this,
      this._globalSettingsClassName.observable.pipe(
        filter(Boolean),
        distinctUntilChanged(),
        switchMap((className) => subscribeBuildifyGlobalSettings(className)(selectionSet(() => BuildifyGlobalSettings, 3))),
        takeUntil(this.disconnected)
      )
    );
  }
  willUpdate(_changedProperties) {
    super.willUpdate(_changedProperties);
    const className = this.globalSettingsClassName || this._consumedGlobalSettingsClassName.value;
    if (className !== this._globalSettingsClassName.value)
      this._globalSettingsClassName.next(className);
  }
};
__decorateClass([
  state()
], XBuildifyGlobalSettingsFormField.prototype, "_globalSettings", 2);
XBuildifyGlobalSettingsFormField = __decorateClass([
  customElement("x-buildify-global-settings-formfield")
], XBuildifyGlobalSettingsFormField);
export {
  XBuildifyGlobalSettingsFormField
};
